import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const Separator = styled.span`
  margin: 0 5px;
`;
